const lookupEnv = (envVar: keyof EnvVars, buildValue: string | undefined, fallback: string): string => {
  let result

  if (window.FAB_SETTINGS) {
    result = window.FAB_SETTINGS[envVar]
  } else {
    result = buildValue
  }

  if (!result) {
    console.warn(`${envVar} not specified, using default value: ${fallback}`)
  }

  return result || fallback
}

export const EnvVars: EnvVars = {
  API_URL: lookupEnv('API_URL', process.env.REACT_APP_API_URL, 'http://localhost:9000'),
  PLATFORM_URL: lookupEnv('PLATFORM_URL', process.env.REACT_APP_PLATFORM_URL, 'http://localhost:3000'),
  APP_URL: lookupEnv('APP_URL', process.env.REACT_APP_APP_URL, 'http://localhost:3008'),
  ADMIN_URL: lookupEnv('ADMIN_URL', process.env.REACT_APP_ADMIN_URL, 'http://localhost:3001'),
  ENVIRONMENT: lookupEnv('ENVIRONMENT', process.env.REACT_APP_ENVIRONMENT, 'development') as EnvVars['ENVIRONMENT'],
}

export default EnvVars
